import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { useNavigate } from "react-router-dom";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function DialogCV({open, setOpen}) {
 
  const navigate = useNavigate();

  const navegarEng = () => {
    navigate("/cv-english");
    setOpen(false);
  };

  const navegarEsp = () => {
    navigate("/cv-espanol");
    setOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
  }

  return (
    <React.Fragment>
      
      <Dialog
        open={open}
        slots={{
          transition: Transition,
        }}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
         sx={{
            '& .MuiPaper-root': {
                backgroundColor: '#4c4d55',  // color de fondo del dialog
            }
        }}
      >
        <DialogTitle>{""}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <p className='text-white'>Selecciona una versión para descargar</p>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={navegarEng}> <p className='text-amarillo'> Inglés </p> </Button>
          <Button onClick={navegarEsp}> <p className='text-amarillo'> Español </p> </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}